import { render, staticRenderFns } from "./uploadTask.vue?vue&type=template&id=74f8e7d7&scoped=true"
import script from "./uploadTask.vue?vue&type=script&lang=js"
export * from "./uploadTask.vue?vue&type=script&lang=js"
import style0 from "./uploadTask.vue?vue&type=style&index=0&id=74f8e7d7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f8e7d7",
  null
  
)

export default component.exports